import { List } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo/Logo';
import { PlatformSettingsIcon } from './PlatformSettingsIcon';
import { UserSection } from './UserSection';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logoWrapper: {
      padding: theme.spacing(1),
      height: '64px',
    },
    toolbar: {
      display: 'flex',
      backgroundColor: theme.palette.white,
      color: theme.palette.secondary.main,
      margin: 0,
    },
    list: {
      display: 'flex',
      padding: 0,
      height: '64px',
    },
    icon: {
      '& svg': {
        fill: theme.palette.secondary.main,
      },
    },
  }),
);

export type WbAppToolbarProps = {
  homeURL: string;
  searchButton: ReactNode;
  children: ReactNode[];
  notificationsIcon?: ReactNode;
  showPlatformSettings?: boolean;
};

export function WbAppToolbar(props: WbAppToolbarProps) {
  const {
    homeURL,
    searchButton,
    children,
    notificationsIcon,
    showPlatformSettings,
  } = props;
  const classes = useStyles();

  return (
    <AppBar
      position="sticky"
      color="transparent"
      style={{ boxShadow: '0px 0px 50px #92929226' }}
      id="witboost-toolbar"
    >
      <Toolbar className={classes.toolbar}>
        <Link className={classes.logoWrapper} to={homeURL}>
          <Logo />
        </Link>
        <List component="nav" aria-label="menu voices" className={classes.list}>
          {children}
        </List>
        <span style={{ flex: 1 }} />
        {searchButton}
        {showPlatformSettings && <PlatformSettingsIcon />}
        <div className={classes.icon}>{notificationsIcon}</div>
        <UserSection />
      </Toolbar>
    </AppBar>
  );
}
